import { render, staticRenderFns } from "./IndustryPractice.vue?vue&type=template&id=947bcade&"
import script from "./IndustryPractice.vue?vue&type=script&lang=js&"
export * from "./IndustryPractice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports